import { Heading_1 as Heading1, FormBody } from '@huggg/react-components';
import PropTypes from 'prop-types';
import React from 'react';
import BackButton from '../BackButton/BackButton';
import { PersonalDetailsDialog } from './PersonalDetailsDialog';
import { getFormModel } from './formModel';
import { normaliseMiddleName } from './normaliseMiddleName';
import styles from './prepaidCard.module.scss';

export const PrepaidForm = (props) => {
  const { onSubmit, onBack, formData, showMiddleName = false } = props;
  const values = normaliseMiddleName(formData, showMiddleName);
  const initialValues =
    values != null && showMiddleName === true
      ? { middleName: '', ...values }
      : values;
  return (
    <>
      <div className={styles.personalDetailsHeader}>
        <Heading1>Add your personal details</Heading1>
        <PersonalDetailsDialog />
      </div>
      <FormBody
        onConfirm={onSubmit}
        buttonCopy="SUBMIT MY REQUEST"
        initialValues={initialValues}
        model={getFormModel(showMiddleName)}
      />
      <div className={styles.backButton}>
        <BackButton onClick={onBack} />
      </div>
    </>
  );
};

PrepaidForm.propTypes = {
  showMiddleName: PropTypes.bool,
  formData: PropTypes.object.isRequired,
  onSubmit: PropTypes.func.isRequired,
  onBack: PropTypes.func.isRequired,
};
